











import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo } from './api';

@Component
export default class ViewHolder extends Vue {
  async created() {
    const retBaseInfo = await getBaseInfo();
    if (retBaseInfo.data.activityId) {
      this.$addPv(retBaseInfo.data.activityId);
    }
    window.userInfoChange = () => {
      location.reload();
    };
  }
}
